
import { computed } from 'vue'

export default {
  name: 'PreviewPairData',

  props: {
    label: String,
    content: String,
    hideEmptyContent: {
      type: Boolean,
      default: false
    },
    hasBorder: {
      type: Boolean,
      default: true
    }
  },

  setup(props: any) {
    const contentHtml = computed(() => {
      if (props.content || props.hideEmptyContent) return props.content
      return '－'
    })

    return {
      contentHtml
    }
  }
}
